var React = require('react');

function Ios (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m34.24 26.749a11.129 11.129 0 0 0 6.76 10.188 27.553 27.553 0 0 1 -3.487 7.163c-2.1 3.067-4.277 6.123-7.708 6.186-3.371.062-4.455-2-8.31-2s-5.058 1.936-8.249 2.061c-3.312.125-5.834-3.317-7.95-6.373-4.323-6.251-7.627-17.664-3.191-25.368a12.325 12.325 0 0 1 10.419-6.306c3.252-.062 6.322 2.188 8.31 2.188s5.717-2.706 9.638-2.308a11.762 11.762 0 0 1 9.209 4.994 11.387 11.387 0 0 0 -5.441 9.58m-6.34-18.715a11.09 11.09 0 0 0 2.622-8.039 11.287 11.287 0 0 0 -7.417 3.816 10.538 10.538 0 0 0 -2.671 7.784 9.338 9.338 0 0 0 7.466-3.561","fill":"#d8d8d8"}));
}

Ios.defaultProps = {"height":"50.35","viewBox":"0 0 40.997 50.35","width":"40.997"};

module.exports = Ios;

Ios.default = Ios;
